// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Checkbox,
  Form,
  Input,
  Message,
  Modal,
  Space,
  Table,
  TableColumnProps,
  Tag
} from '@arco-design/web-react';

import './index.scss';

import { get, post } from '../requestNew';
import { Item, SectorItem } from './types';

const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;

function SectorsManagement() {
  const [form] = Form.useForm<Item>();
  const [formSearch] = Form.useForm<Item>();
  const [options, setOptions] = useState<[]>([]);
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);

  const formRef = useRef<any>({});

  const columns: TableColumnProps[] = [
    {
      title: '股票代码',
      width: 100,
      dataIndex: 'stockCode'
    },
    {
      title: '股票名称',
      dataIndex: 'stockName',
      width: 150
    },
    {
      title: '归属已选概念/板块',
      dataIndex: 'sectors',
      width: 200,
      render: list => (
        <Space wrap>
          {list.map((item: SectorItem) => (
            <Tag key={item.id} bordered color="gray">
              {item.name}
            </Tag>
          ))}
        </Space>
      )
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 80,
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            编辑
          </Button>
        </>
      )
    }
  ];

  const getSector = () => {
    get<any>('/marketSector/admin/page', { pageNum: 1, pageSize: 1000 })
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const list = (data?.list || []).map((item: SectorItem) => {
            const { id, name } = item;
            return { label: name, value: id };
          });
          setOptions(list);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const getList = (page?: { pageNum: number; pageSize: number }) => {
    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize,
      ...page
    };

    get<any>('/marketStock/admin/page', params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total } = data;
          setTotal(total);
          setDataList(list || []);
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  const search = () => {
    setPageNum(1);
    setPageSize(20);
    const params = {
      pageNum: 1,
      pageSize: 20
    };
    getList(params);
  };

  const add = () => {
    formRef.current = {};
    form.resetFields();
    setVisible(true);
  };

  const edit = (record: Item) => {
    formRef.current = record;
    const sectorIds = (record.sectors || []).map(item => item.id);
    form.setFieldsValue({ ...record, sectorIds });
    setVisible(true);
  };
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };
  const onOk = () => {
    form.validate().then(values => {
      post('/marketStock/admin/saveSectorMapping', values)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            getList();
            editCancel();
            Message.success('操作成功');
          } else {
            Message.error(message);
          }
        })
        .catch(e => {
          Message.error('网络错误!');
          console.log(e);
        });
    });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);
  useEffect(() => {
    getSector();
  }, []);

  return (
    <div className="sectors table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="板块名称" field="keyword">
            <Input style={{ width: 200 }} allowClear />
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={search}>
              查询
            </Button>
          </FormItem>
          {/* <FormItem>
            <Button type="outline" onClick={handleReset}>
              重置
            </Button>
          </FormItem> */}
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add}>
              新增
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑' : '新增'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        className="stock-management-modal"
        maskClosable={false}
      >
        <Form form={form}>
          <FormItem className="arco-form-item-title">
            股票代码(6位数字代码)<span className="red-star"></span>
          </FormItem>
          <FormItem
            field="stockCode"
            rules={[
              { required: true, message: '请输入股票代码' },
              { match: /^[0-9]{6}$/, message: '请输入6位数字股票代码' }
            ]}
          >
            <Input placeholder="请输入板块名称" />
          </FormItem>
          <FormItem className="arco-form-item-title">
            股票名称<span className="red-star"></span>
          </FormItem>
          <Form.Item field="stockName" rules={[{ required: true, message: '请输入板块名称' }]}>
            <Input placeholder="请输入板块名称" />
          </Form.Item>
          <FormItem className="arco-form-item-title">多组绑定概念板块(多对多网状映射核心)</FormItem>
          <Form.Item field="sectorIds">
            <CheckboxGroup options={options} style={{ display: 'block' }} />
          </Form.Item>
          <Form.Item field="id" hidden>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default SectorsManagement;
